import React from 'react'
import Nav from './Nav'
import { Footer } from './Footer1'

const Wishlist = () => {
  return (
    <div>
      <Nav/>
<Footer/>
    </div>
  )
}

export default Wishlist